<script setup lang="ts">
import { NodeViewContent, nodeViewProps, NodeViewWrapper } from "@tiptap/vue-3";
import { MailMjmlButton } from "#components";
import { createButtonBlock } from "~/stores/mail-block-editor/defaults";

const props = defineProps(nodeViewProps);
const store = useMailStore();
const fontStore = useFontStore();
const theme = computed(() => {
    const theme = createButtonBlock();

    const topLeft =
        props.node.attrs.borderTopLeftRadius ?? theme?.borderTopLeftRadius;
    const bottomLeft =
        props.node.attrs.borderBottomLeftRadius ??
        theme?.borderBottomLeftRadius;
    const topRight =
        props.node.attrs.borderTopRightRadius ?? theme?.borderTopRightRadius;
    const bottomRight =
        props.node.attrs.borderBottomRightRadius ??
        theme?.borderBottomRightRadius;
    return store.fieldCollection.replaceContent({
        padding: `${props.node.attrs.paddingTop ?? theme.paddingTop} ${props.node.attrs.paddingRight ?? theme.paddingRight} ${props.node.attrs.paddingBottom ?? theme.paddingBottom} ${props.node.attrs.paddingLeft ?? theme.paddingLeft}`,
        width: props.node.attrs?.width ?? theme?.width,
        borderBottom: props.node.attrs.borderBottomWidth
            ? `${props.node.attrs.borderBottomWidth ?? ""} solid`.trim()
            : undefined,
        borderLeft: props.node.attrs.borderLeftWidth
            ? `${props.node.attrs.borderLeftWidth ?? ""} solid`.trim()
            : undefined,
        borderRight: props.node.attrs.borderRightWidth
            ? `${props.node.attrs.borderRightWidth ?? ""} solid`.trim()
            : undefined,
        borderTop: props.node.attrs.borderTopWidth
            ? `${props.node.attrs.borderTopWidth ?? ""} solid`.trim()
            : undefined,
        borderRadius: `${topLeft} ${topRight} ${bottomRight} ${bottomLeft}`,
        alignment: props.node.attrs?.alignment ?? theme?.alignment,
        marginTop: props.node.attrs?.marginTop ?? theme?.marginTop,
        marginBottom: props.node.attrs?.marginBottom ?? theme?.marginBottom,
        backgroundColor:
            props.node.attrs?.backgroundColor ?? theme?.backgroundColor,
        textColor: props.node.attrs?.textColor ?? theme?.textColor,
        fontFamily: fontStore.findFontFamily(
            props.node.attrs?.fontFamily ?? theme?.fontFamily,
        )?.class,
        fontSize: props.node.attrs?.fontSize ?? theme?.fontSize,
        fontWeight: props.node.attrs?.fontWeight ?? theme?.fontWeight,
        lineHeight: props.node.attrs?.lineHeight ?? theme?.lineHeight,
        letterSpacing: props.node.attrs?.letterSpacing ?? theme?.letterSpacing,
    });
});
</script>

<template>
    <NodeViewWrapper class="button" :as="MailMjmlButton" :background-color="theme.backgroundColor" :width="theme.width"
        :align="theme.alignment" :padding-top="theme.marginTop" :padding-bottom="theme.marginBottom"
        :color="theme.textColor" :class="theme.fontFamily" :border-radius="theme.borderRadius"
        :font-size="theme.fontSize" :font-weight="theme.fontWeight?.toString()"
        :line-height="theme.lineHeight?.toString()" :letter-spacing="theme.letterSpacing?.toString()"
        :inner-padding="theme.padding" @click.stop="store.focusedJsonId = node.attrs.id">
        <NodeViewContent />
    </NodeViewWrapper>
</template>
